import { UseCase } from '@/core/base/use-case';
import { LoginGuestRequest } from '../models/loginGuest-request.model';
import { LoginGuestResponse } from '../models/loginGuest-response.model';
import { UserRepository } from '../repositories/user.respository';
import { Observable } from 'rxjs';

export class LoginGuestUseCase
    implements UseCase<LoginGuestRequest, LoginGuestResponse>
{
    constructor(private readonly repository: UserRepository) {}

    execute(request: LoginGuestRequest): Observable<LoginGuestResponse> {
        return this.repository.loginGuest(request);
    }
}
